import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {ClassroomState, ClassroomStateModel} from '@app/state/classroom-state.service';
import {Store} from '@ngxs/store';

@Injectable({
  providedIn: 'root'
})
export class CommandService {
  private room: ClassroomStateModel;

  constructor(
    private http: HttpClient,
    private store: Store
  ) {
    this.listenStoreChanges();
  }

  private listenStoreChanges() {
    this.store.select(ClassroomState).subscribe((room: ClassroomStateModel) => {
      this.room = room;
    });
  }

  // public toggleMuteStudent(studentId, doMute): Observable<any> {
  //   return this.http.get(`${this.room.vcrURL}/commands/mute-student-audio/?mute=${doMute}&studentId=${studentId}`);
  // }

  // public toggleMuteSelfAudio(id): Observable<any> {
  //   return this.http.get(`${this.room.vcrURL}/commands/student-mute-himself?id=${id}`);
  // }

  // toggleMuteStudentVideo(studentId: number, doMute: boolean): Observable<any> {
  //   return this.http.get(`${this.room.vcrURL}/commands/mute-student-video?studentId=${studentId}&mute=${doMute}`);
  // }

  // toggleMuteRoom(doMute: boolean): Observable<any> {
  //   return this.http.get(`${this.room.vcrURL}/commands/mute-all-students/${doMute}`);
  // }

  // dropMuteClassroomButtonAndStoreMutedUsersCommand(unmutedStudentId, studentIdsWhichMustRemainMuted: number []): Observable<any> {
  //   return this.http.post(`${this.room.vcrURL}/commands/drop-mute-classroom-button-and-store-muted-users?unmutedStudentId=${unmutedStudentId}`, studentIdsWhichMustRemainMuted);
  // }

  // joinToPrivateChat(userId: number) {
  //   return this.http.get(`${this.room.vcrURL}/commands/start-private-chat?userId=${userId}`);
  // }

  // closePrivateChat() {
  //   return this.http.get(`${this.room.vcrURL}/commands/close-private-chat`);
  // }

  // excludeUserFromPrivateChat(studentId: number) {
  //   return this.http.get(`${this.room.vcrURL}/commands/exclude-user-from-private-chat?userId=${studentId}`);
  // }

  // getMutedStudentsList(): Observable<number[]> {
  //   return this.http.get(`${this.room.vcrURL}/commands/get-muted-students-list`).pipe(map(result => {
  //     return (JSON.parse(result + '') as string []).map(value => parseInt(value));
  //   }));
  // }

  // startGameMode(): Observable<any> {
  //   return this.http.get(`${this.room.vcrURL}/commands/toggle-game-mode?on=true`);
  // }
  //
  // endGameMode(): Observable<any> {
  //   return this.http.get(`${this.room.vcrURL}/commands/toggle-game-mode?on=false`);
  // }

  // updateTeamsInfo(teams: Team[], lastTeamId): Observable<any> {
  //   return this.http.post(`${this.room.vcrURL}/commands/update-teams-info?lastTeamId=` + lastTeamId, teams);
  // }

  // changeTeamName(teamId, teamName): Observable<any> {
  //   return this.http.get(`${this.room.vcrURL}/commands/update-team-name?team=${teamId}&name=${teamName}`);
  // }

  // toggleTeamTalk(isEnabled): Observable<any> {
  //   return this.http.get(`${this.room.vcrURL}/commands/toggle-team-talk?on=${isEnabled}`);
  // }

  // changeTeacherTeam(teamId): Observable<any> {
  //   return this.http.get(`${this.room.vcrURL}/commands/toggle-team-talk-teacher?teamId=${teamId}`);
  // }

  // endLesson(): Observable<any> {
  //   return this.http.get(`${this.room.vcrURL}/commands/purge`);
  // }

  // setCurrentClass(currentClassInfo: CurrentClass): Observable<any> {
  //   return this.http.post(`${this.room.vcrURL}/commands/set-current-class`, currentClassInfo)
  //     .pipe(concatMap(() => {
  //       return this.toggleDndModeCommand(!!currentClassInfo.groupId);
  //     }));
  // }

  // getStudentsByGroupId(groupId: number, lessonId: number): Observable<any> {
  //   return this.http.get(`${this.room.vcrURL}/commands/get-students-by-group-id?groupId=${groupId}&lessonId=${lessonId}`);
  // }
  //
  // checkAndWriteCookieIfUserIsCurrentClassParticipant(): Observable<any> {
  //   return this.http.get(`${this.room.vcrURL}/commands/check-and-write-cookie-if-user-is-current-class-participant`);
  // }

  // toggleDndModeCommand(enable: boolean, groupId: number = -1): Observable<any> {
  //   return this.http.get(`${this.room.vcrURL}/commands/toggle-do-not-disturb?enable=${enable}&groupId=${groupId}`);
  // }

  // toggleFullScreen(enable: boolean): Observable<any> {
  //   return this.http.get(`${this.room.vcrURL}/commands/toggle-fullscreen?fullscreen=${enable}`);
  // }

  // addStarToStudent(studentId, sticker): Observable<any> {
  //   return this.http.get(`${this.room.vcrURL}/commands/add-star?studentId=${studentId}&sticker=${sticker}`);
  // }

  // removeStarFromStudent(studentId): Observable<any> {
  //   return this.http.get(`${this.room.vcrURL}/commands/remove-star?studentId=${studentId}`);
  // }

  // redirectStudent(userId, classroomNumber): Observable<any> {
  //   return this.http.get(`${this.room.vcrURL}/commands/redirect?studentId=${userId}&classroomNumber=${classroomNumber}`);
  // }

  // redirectClassroom(classroomNumber): Observable<any> {
  //   return this.http.get(`${this.room.vcrURL}/commands/redirect-classroom?classroomNumber=${classroomNumber}`);
  // }

  // resetWRTC(): Observable<any> {
  //   return this.http.get(`${this.room.vcrURL}/commands/reset-wrtc`);
  // }

  // changeStudentVideoFrameRate(userId, frameRate): Observable<any> {
  //   return this.http.get(`${this.room.vcrURL}/commands/wrtc-set-frame-rate?studentId=${userId}&frameRate=${frameRate}`);
  // }

  // changeStudentVideoResolution(userId, resolution): Observable<any> {
  //   return this.http.get(`${this.room.vcrURL}/commands/wrtc-set-video-resolution?studentId=${userId}&resolution=${resolution}`);
  // }

  // reloadStudent(id): Observable<any> {
  //   return this.http.get(`${this.room.vcrURL}/commands/reload-student?studentId=${id}`);
  // }

  // expelStudent(id): Observable<any> {
  //   return this.http.get(`${this.room.vcrURL}/commands/expel-student?studentId=${id}`);
  // }

  // unloadAssignment(): Observable<any> {
  //   return this.http.get(`${this.room.vcrURL}/commands/unload-assignment`);
  // }

  // loadAssignment(assignmentGroupId): Observable<any> {
  //   return this.http.get(`${this.room.vcrURL}/commands/load-assignment?assignmentGroupId=${assignmentGroupId}`);
  // }

  // refreshStudentsAssignment(): Observable<any> {
  //   return this.http.get(`${this.room.vcrURL}/commands/refresh-students-assignment`);
  // }

  // refreshAssignment(): Observable<any> {
  //   return this.http.get(`${this.room.vcrURL}/commands/refresh-assignment`);
  // }

  // loadLastHomeworkAssignmentReport(lastAssignmentId): Observable<any> {
  //   return this.http.get(`${this.room.vcrURL}/commands/load-last-homework-assignment-report?lastAssignmentId=${lastAssignmentId}`);
  // }

  // studentChangeViewPortTab(studentId, tabIndex): Observable<any> {
  //   return this.http.get(`${this.room.vcrURL}/commands/student-change-view-port-tab?studentId=${studentId}&tabIndex=${tabIndex}`);
  // }

  // toggleTimer(start: boolean, minutes: number): Observable<any> {
  //   return this.http.get(`${this.room.vcrURL}/commands/toggle-break-timer?start=${start}&minutes=${minutes}`);
  // }

  // addCorrectAnswerScore(userId: number): Observable<any> {
  //   return this.http.get(`${this.room.vcrURL}/commands/send-correct?userId=${userId}`);
  // }

  // sendMassage(messageModel: any): Observable<any> {
  //   return this.http.post(`${this.room.vcrURL}/commands/send-message`, messageModel);
  // }

  // shareWbWithStudent(targetId: number, share: boolean): Observable<any> {
  //   return this.http.get(`${this.room.vcrURL}/commands/share-whiteboard-whit-student?targetId=${targetId}&share=${share}`);
  // }

  // clearAllMessages(): Observable<any> {
  //   return this.http.get(`${this.room.vcrURL}/commands/clean-messages`);
  // }

  // clearUserMessages(userId: number): Observable<any> {
  //   return this.http.get(`${this.room.vcrURL}/commands/clear-user-chat?userId=${userId}`);
  // }

  // resetUserPoints(userId: number): Observable<any> {
  //   return this.http.get(`${this.room.vcrURL}/commands/reset-answers-counter?userId=${userId}`);
  // }

  // toggleAccessToWBAssignmentTabsSwitcherToAllStudents(enable): Observable<any> {
  //   return this.http.get(`${this.room.vcrURL}/commands/toggle-access-to-wb-assignment-tabs-switcher-to-all-students?enable=${enable}`);
  // }

  // microphoneDeniedAccess(): Observable<any> {
  //   return this.http.get(`${this.room.vcrURL}/commands/web-cam-denied-access`);
  // }
  //
  // webCamDeniedAccess(): Observable<any> {
  //   return this.http.get(`${this.room.vcrURL}/commands/microphone-denied-access`);
  // }

  // studentRiseHand(nameSid: string) {
  //   return this.http.get(`${this.room.vcrURL}/commands/student-raise-hand?nameSid=${nameSid}`);
  // }

  // cancelRiseHand(userId: number) {
  //   return this.http.get(`${this.room.vcrURL}/commands/cancel-raised-hand?userId=${userId}`);
  // }

  // addTeamScore(teamId: number) {
  //   return this.http.get(`${this.room.vcrURL}/commands/add-score?teamId=${teamId}`);
  // }

  // removeTeamScore(teamId: number) {
  //   return this.http.get(`${this.room.vcrURL}/commands/remove-score?teamId=${teamId}`);
  // }

  // sendLogout(): Observable<any> {
  //   return this.http.get(`${this.room.vcrURL}/commands/logout`);
  // }

  // setNickname(userId: number, nickname: string): Observable<any> {
  //   return this.http.get(`${this.room.vcrURL}/commands/update-current-teacher-nickname?userId=${userId}&nickname=${nickname}`);
  // }
  //
  // expelTeacher(userId: number): Observable<any> {
  //   return this.http.get(`${this.room.vcrURL}/commands/expel?userId=${userId}`);
  // }

  // changeStudentVoiceLevel(userId: number, voiceLevel): Observable<any> {
  //   return this.http.get(`${this.room.vcrURL}/commands/change-student-voice-volume?userId=${userId}&voiceLevel=${voiceLevel}`);
  // }

  // toggleBlackboard(show: boolean): Observable<any> {
  //   return this.http.get(`${this.room.vcrURL}/commands/toggle-background?show=${show}`);
  // }
  //
  // cleanAllBlackboard(order: number): Observable<any> {
  //   return this.http.get(`${this.room.vcrURL}/commands/clear-blackboard?order=${order}`);
  // }
  //
  // blackboardDraw(drawSegmentModel: BlackboardInfo): Observable<any> {
  //   return this.http.post(`${this.room.vcrURL}/commands/draw-segment-blackboard`,drawSegmentModel);
  // }
  //
  // blackboardText(text: string): Observable<any> {
  //   return this.http.post(`${this.room.vcrURL}/commands/send-bb-text`,text);
  // }
  //
  // togglePointer(order: number): Observable<any> {
  //   return this.http.get(`${this.room.vcrURL}/commands/toggle-pointer?order=${order}`);
  // }
}
